// Hook partagé Conformité : fetch /api/metier/stats/dashboard-conformite
// avec auth Bearer + cookie + X-Tenant-ID dynamique.
// Tous les widgets Conformité s'y branchent — pour éviter N appels en V1,
// on pourrait factoriser via un contexte ; en pratique chaque widget fait
// son propre fetch (le navigateur cache et le backend renvoie en <100ms).
import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

function getTenant() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return u?.tenant_id || u?.tenant?.slug || "tef";
  } catch { return "tef"; }
}

export function useConformiteFetch(url = "/api/metier/stats/dashboard-conformite", deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("session_token");
    const headers = {
      "X-Tenant-ID": getTenant(),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    fetch(`${API}${url}`, { headers, credentials: "include" })
      .then((r) => (r.ok ? r.json() : Promise.reject(`HTTP ${r.status}`)))
      .then((d) => { if (!cancelled) setData(d); })
      .catch((e) => { if (!cancelled) setError(String(e.message || e)); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, deps);

  return { data, loading, error };
}

export function fmtEuro(n) {
  if (!n && n !== 0) return "-";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
}
